import * as React from 'react';
import strings from 'owa-strings/owa-txp-strings';

export default function(): JSX.Element {
    return (
        <div>
            <div>{strings.negativeTicketPopUpDonateEmailText}</div>
            <br />
            <div>{strings.negativeTicketPopUpEmailUseText}</div>
        </div>
    );
}
